<template>
    <div class="am-training-menu">

      <play-video v-show="showVideoModal" :videoCode="videoHelp" :videoType="videoHelpType"></play-video>
      <div class="am-training-header am-main-top-box">
            <span class="am-main-top-box-title">Training Menu</span>
            <span class="float-right py-0 px-3"><a href="#" @click="videoModal()" ><svg-icon icon="video" title="Training" class="am-glyphicon-medium am-glyphicon-white"></svg-icon></a></span>
        </div>

        <div class="row">
            <div class="leftcolumn">
                <div class="am-video-screen">
                    <fieldset class="video-screen-border">
                        <legend class="video-screen-border">Playing Now -> {{videoDisplay.description}}</legend>
                        <iframe :src="getUrl(videoDisplay.videoCode)" allowfullscreen frameborder="0"></iframe>
                    </fieldset>
                </div>

                <div class="am-upgrade" v-if="$store.state.auth.configLoaded">
                    <div class="am-upgrade-header am-main-top-box">
                        <span class="am-main-top-box-title">Explore Our Features</span>
                    </div>

                    <div class="upgrade-packages-images" @click="clickPackage($event)">
                        <img src="@/assets/gold.png" alt="gold" v-if="$store.state.auth.config.liteSwitch === 1">
                        <img src="@/assets/platinum.png" alt="platinum" v-if="$store.state.auth.config.liteSwitch < 2">
                        <img src="@/assets/diamond.png" alt="diamond" v-if="$store.state.auth.config.liteSwitch < 3">
                        <img src="@/assets/enterprise.png" alt="enterprise" v-if="$store.state.auth.config.liteSwitch < 4">
                        <img src="@/assets/mobile_solutions.png" alt="agent-alive" v-if="$store.state.auth.config.liteSwitch !== 1 ">
                        <img src="@/assets/website_integration.png" alt="website-design" v-if="$store.state.auth.config.liteSwitch > 1 ">
                        <img src="@/assets/lead_integration.png" alt="leads-matrix" v-if="$store.state.auth.config.liteSwitch > 2">
                        <img src="@/assets/document_management.png" alt="easy-file" v-if="$store.state.auth.config.liteSwitch > 3">
                    </div>

                </div>
            </div>

            <div class="rightcolumn">
                <div class="am-video-search">
                    <div class="am-video-search-header am-main-top-box">
                        <span class="am-main-top-box-title">Video Search</span>
                    </div>

                    <div class="search-container">
                        <form class="form-inline" v-on:submit.prevent>
                            <input class="form-control" type="text" placeholder="Search..." v-model="filterCriteria">
                            <button type="button" class="btn btn-sm" @click="resetFilter()">Reset</button>
                        </form>
                    </div>

                    <div class="search-results-title">
                        <span>Total Search Results: <strong>{{ filteredVideos !== null ? filteredVideos.length : 'N/A' }}</strong></span>
                    </div>

                    <div class="search-table">
                        <table class="table table-hover scrollabletable">
                            <thead>
                            <tr>
                              <th @click="sort('description')" class="am-main-top-box am-main-top-box-title">Video Name<span><img v-if="sortData.currentSort === 'description'" :src="sorterArrow"></span></th>

                            </tr>
                            </thead>
                            <tbody class="am-trainingTab-font">
                            <tr v-for="video in pageVideos" :key="video.id">
                              <td @click="changeVideo(video)">{{ video.description }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="am-training-menu-pagination">
                    <pagination :allData="filteredVideos" :pageSize="pageSize" :sortData="sortData" @setPageData="setPageData"></pagination>
                </div>
            </div>
        </div>

        <div class="am-footer-training">
            <div class="am-footer-header am-main-top-box">
                <span class="am-main-top-box-title">Related Videos</span>
            </div>

            <div class="footer-video-card">
                <div class="am-video-frame" v-for="relatedVideo in relatedVideos" :key="relatedVideo.key">
                  <img src="@/assets/VideoThumbnail.png" @click="changeVideo(relatedVideo)"/>
                  <span class="am-video-caption">{{relatedVideo.description}}</span>
                </div>
            </div>
            <div class="am-footer-header-bottom am-main-bottom-box"></div>
        </div>
    </div>
</template>

<script>
import api from './../http'
import pagination from '@/components/pagination/pagination.vue'
import playVideo from '@/components/PlayVideo.vue'
import sort from '@/mixins/tableSorter'

export default {
  data: function () {
    return {
      name: 'trainingTab',
      pageSize: 15,
      videoSearch: '',
      pageVideos: [],
      filterCriteria: '',
      videoDisplay: {
        id: 1,
        videoCode: '349499648',
        videoType: 2,
        description: 'Welcome To Agency Matrix',
        tags: []
      },
      relatedVideos: [],
      showVideoModal: false,
      videoHelp: '335222109',
      videoHelpType: 'vimeo'
    }
  },

  props: {
    id: { //  videoId
      type: [Number, String],
      required: false
    }
  },

  computed: {
    videoTags () {
      return (this.videoDisplay.tags).map(tag => tag.id)
    },

    filteredVideos () {
      if (this.filterCriteria.length === 0) {
        return this.allVideos
      }
      return this.filterVideos(this.allVideos, this.filterCriteria)
    }
  },

  components: {
    pagination,
    playVideo,
  },

  mixins: [sort],

  asyncComputed: {
    allVideos () {
      let self = this
      return api.makeRequest('/training').then(
        (data) => {
          self.setVideo()
          return data.data.results
        }
      )
    }
  },

  methods: {
    setVideo() {
      let self = this
      if(self.id !== null && self.id !== 0 && self.id !== undefined) {
        api.makeRequest('/training/' + self.id).then(
          (data) => {
            self.videoDisplay.id = data.data.results.id
            self.videoDisplay.videoCode = data.data.results.videoCode
            self.videoDisplay.videoType = data.data.results.videoType
            self.videoDisplay.description = data.data.results.description
          }
        )
      } else {
        self.videoDisplay.id = 1
        self.videoDisplay.videoCode = '349499648'
        self.videoDisplay.videoType = 2
        self.videoDisplay.description = 'Welcome To Agency Matrix'
      }
      return self.videoDisplay.videoCode
    },
    setPageData (data) {
      this.pageVideos = data
    },

    getUrl (videoCode) {
      return (this.videoDisplay.videoType === 1) ? '//www.youtube.com/embed/' + videoCode : '//player.vimeo.com/video/' + videoCode
    },
    changeVideo (video) {
      this.videoDisplay = video
    },

    filterVideos (allVideos, filterCriteria) {
      filterCriteria = filterCriteria.toLowerCase()
      return allVideos.filter(function (video) {
        var tags = video.tags.filter(function (tag) {
          return tag.description.toLowerCase().indexOf(filterCriteria) > -1
        })
        return tags.length > 0 || video.description.toLowerCase().indexOf(filterCriteria) > -1
      })
    },

    resetFilter () {
      this.filterCriteria = ''
    },
    clickPackage (event) {
      switch (event.target.alt) {
        case 'gold':
          this.videoDisplay.videoCode = '336688842'
          this.videoDisplay.description = 'Upgrade to Gold'
          this.videoDisplay.videoType = 2
          break
        case 'platinum':
          this.videoDisplay.videoCode = '336674301'
          this.videoDisplay.description = 'Upgrade to Platinum'
          this.videoDisplay.videoType = 2
          break
        case 'diamond':
          this.videoDisplay.videoCode = '336674514'
          this.videoDisplay.description = 'Upgrade to Diamond'
          this.videoDisplay.videoType = 2
          break
        case 'enterprise':
          this.videoDisplay.videoCode = '336674414'
          this.videoDisplay.description = 'Upgrade to Enterprise'
          this.videoDisplay.videoType = 2
          break
        case 'agent-alive':
          this.videoDisplay.videoCode = '280572935'
          this.videoDisplay.description = 'Agent Alive'
          this.videoDisplay.videoType = 2
          break
        case 'website-design':
          this.videoDisplay.videoCode = '358899713'
          this.videoDisplay.description = 'Agency Matrix Websites & SEO'
          this.videoDisplay.videoType = 2
          break
        case 'easy-file':
          this.videoDisplay.videoCode = '340767103'
          this.videoDisplay.description = 'Doc Matrix'
          this.videoDisplay.videoType = 2
          break
        default:
      }
    },
    videoModal: function () {
      this.videoDisplay.videoCode = this.setVideo()
      this.showVideoModal = true
      this.$modal.show('playVideo')
    }
  },

  watch: {
    videoTags: function () {
      if (this.videoTags.length === 0) {
        this.relatedVideos = []
        return
      }
      api.makeRequest('/training/tags/' + (this.videoTags).join()).then(
        (data) => {
          this.relatedVideos = data.data.results
        }
      )
    }
  }
}
</script>

<style scoped>
  .table th {
    padding-bottom:5px;
    cursor: pointer;
  }
  .table thead {
    color: white;
    background-color: #444444;
  }
    .am-training-menu {
        background-color: #fcfdfd;
        width: 1300px;
        border: 1px solid grey;
        margin: 12px 0px 30px 12px;
    }

    .am-training-header {
        height: 45px;

    }

    .am-training-header span {
        color: white;
        font-size: 14px;
        font-weight: bold;
        float: left;
        margin-left: 30px;
        margin-top: 10px;
    }

    .leftcolumn {
        float: left;
        margin-left: 60px;
        margin-top: 20px;
        margin-bottom: 18px;
    }

    .am-video-screen iframe {
        width: 580px;
        height: 330px;
    }

    fieldset.video-screen-border {
        border: 1px groove lightgrey !important;
        padding: 0 .6em .5em .6em !important;
    }

    legend.video-screen-border {
        font-size: 11px !important;
        font-weight: bold !important;
        text-align: left !important;
        width:auto;
        padding:0 10px;
        border-bottom:none;
        color: #2A95CC;
    }

    .am-upgrade-header {
        height: 35px;
        margin-top: 5px;
    }

    .am-upgrade-header span {
        color: white;
        font-size: 14px;
        font-weight: bold;
        float: left;
        margin-left: 30px;
        margin-top: 5px;
    }

    .am-upgrade {
        margin-top: 58px;
    }

    .upgrade-packages-images img{
        height: 120px;
        width: 140px;
        display: inline-block;
        margin-top: 15px;
        margin-left: 5px;
    }

    .upgrade-packages-images img:hover{
        cursor: pointer;
    }

    .rightcolumn {
        float: right;
        padding-left: 55px;
        margin-top: 25px;
        font-size: 0.8rem;
    }

    .am-video-search {
        height: 680px;
        width: 550px;
        border: 1px solid grey;
    }

    .am-video-search-header {
        height: 55px;
    }

    .am-video-search-header span{
        color: white;
        font-size: 14px;
        font-weight: bold;
        float: left;
        margin-left: 30px;
        margin-top: 15px;
    }

    .search-container {
        margin-right: 10px;
        padding: 2px;
    }

    .search-container input[type=text] {
        margin-top: 20px;
        margin-left: 18px;
        font-size: 14px;
        border: 1px solid #8c8c8c;
        border-radius: 0px;
        width: 455px;
        height: 35px;
    }

    .search-container  button {
        margin-top: 20px;
        margin-left: 5px;
        font-size: 11px;
        font-weight: bold;
        border: none;
        cursor: pointer;
        padding: 10px;
    }

    .search-container  button:hover {
        background-color: darkgrey;
    }

    .search-results-title {
        float: right;
        margin-right: 20px;
        margin-top: 12px;
        margin-bottom: 8px;
    }

    .table thead{
        background-color: #2A95CC ;
        color: white;
    }

    .table {
        width: 515px;
        margin-left: 18px;

    }

    .table tr{
        line-height: 10px;
    }

    .table td {
        cursor: pointer;
    }
    .scrollabletable thead,.scrollabletable tbody tr{
      display: table;
      width:100%;
      table-layout: fixed;
    }
    .scrollabletable tbody{
      display: block;
      max-height: 420px;
      overflow-y: auto;
    }
    .am-footer-header {
        height: 35px;
        margin-top: 18px;
        width: 1213px;
        margin-left: 35px;
    }

    .am-footer-header-bottom {
        height: 35px;
        margin-top: 18px;

    }

    .am-footer-header span{
        color: white;
        font-size: 14px;
        font-weight: bold;
        float: left;
        margin-left: 30px;
        margin-top: 5px;
    }

    .footer-video-card {
        margin-left: 35px;
    }

    .am-video-frame {
        display: inline-block;
        text-align: center;
        vertical-align: top;
    }

    .am-video-frame img {
        padding: 10px 10px 10px;
        height: 150px;
        width: 300px;
        margin-top: 10px;
        cursor: pointer;
    }

    .am-video-caption {
        display: block;
        max-width: 250px;
        font-weight: bold;
        margin-left: 20px;
    }

    .am-training-menu-pagination {
        float: right;
        margin-top: -50px;
        margin-right: 10px;
    }
</style>
